import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardCoordinatorTopLeftComponent } from './dashboard-coordinator-top-left/dashboard-coordinator-top-left.component';
import { DashboardCoordinatorTopCenterComponent } from './dashboard-coordinator-top-center/dashboard-coordinator-top-center.component';
import { DashboardCoordinatorTopRightComponent } from './dashboard-coordinator-top-right/dashboard-coordinator-top-right.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { DashboardCoordinatorComponent } from './dashboard-coordinator.component';
import { TaskModule } from 'src/app/task/task.module';
import { MessageModule } from 'src/app/message/message.module';
import { EventModule } from 'src/app/event/event.module';
import { DashboardCoordinatorMiddleComponent } from './dashboard-coordinator-middle/dashboard-coordinator-middle.component';
import { NoticeModule } from 'src/app/notice/notice.module';
import { MemberSearchModule } from 'src/app/shared/member-search/member-search.module';

@NgModule({
  declarations: [
    DashboardCoordinatorComponent,
    DashboardCoordinatorTopLeftComponent,
    DashboardCoordinatorTopCenterComponent,
    DashboardCoordinatorTopRightComponent,
    DashboardCoordinatorMiddleComponent],
  imports: [
    CommonModule,
    SharedModule,
    TaskModule,
    MessageModule,
    EventModule,
    NoticeModule,
    MemberSearchModule
  ]
})
export class DashboardCoordinatorModule { }
